import { createAction } from '@reduxjs/toolkit'

import { 
  GetFlagsPayload,
  UpdateFlagsStatusPayload
} from './flagsDomain'

export const fetchFlagTypes = createAction("FETCH_FLAG_TYPES_SAGA")
export const fetchFlags = createAction<GetFlagsPayload>("FETCH_FLAGS_SAGA")
export const updateFlagsStatus = createAction<UpdateFlagsStatusPayload>("UPDATE_FLAG_STATUS_SAGA")